<div class="page-header">
  <app-page-title>
    <a page-title-action class="btn btn-primary btn-sm d-inline-flex align-items-center gap-2"
       [routerLink]="['/wss', 'new']">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14"/>
        <path d="M12 5v14"/>
      </svg>
      <span>เพิ่มข้อมูล</span>
    </a>
  </app-page-title>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white">
    <form>
      <div class="d-flex align-items-center gap-2 flex-wrap master-filter-row">
        <div class="d-flex align-items-center gap-2 flex-wrap flex-auto">
          <div class="input-group input-group-sm master-search-group">
            <input type="text" class="form-control" name="searchQuery"
                   placeholder="ชื่อผู้ใช้งาน Web Service API หรือ ConsumerKey"
                   [(ngModel)]="searchQuery"
                   (keyup.enter)="onSearchChange()"/>
            <button class="btn btn-default" (click)="onSearchChange()" type="button">
              <i class="bi bi-search"></i>
            </button>
          </div>
          <button type="reset" class="btn btn-sm btn-default" (click)="clearSearch()">ล้าง</button>
          <div class="master-status-filter">
            <select class="form-select form-select-sm master-status-select" [(ngModel)]="stateFilter"
                    name="stateFilter" (ngModelChange)="onSearchChange()">
              <option [ngValue]="null">ทั้งหมด</option>
              <option [ngValue]="1">เผยแพร่</option>
              <option [ngValue]="0">ไม่เผยแพร่</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead class="bg-light">
        <tr>
          <th class="text-center w-60px">No.</th>
          <th nowrap class="text-center">สถานะ</th>
          <th nowrap>ชื่อผู้ใช้งาน Web Service API</th>
          <th nowrap>ConsumerKey</th>
          <th nowrap>Email</th>
          <th nowrap>ผู้สร้าง</th>
          <th nowrap>วันที่สร้าง</th>
          <th class="text-center bg-light sticky-col sticky-col-header sticky-col-manage-actions">
            จัดการ
          </th>
        </tr>
        </thead>
        <tbody>
          @if (isLoading()) {
            <tr>
              <td colspan="8" class="text-center py-5">กำลังโหลดข้อมูล...</td>
            </tr>
          } @else if (displayedItems().length === 0) {
            <tr>
              <td colspan="8" class="empty-cell">
                - ไม่มีข้อมูล -
              </td>
            </tr>
          } @else {
            @for (item of displayedItems(); track item.id; let i = $index) {
              <tr>
                <td class="text-center">{{ (page() - 1) * pageSize() + i + 1 }}</td>
                <td class="text-center">
                  <button type="button" class="btn p-0 border-0 bg-transparent state-toggle"
                          [disabled]="togglingId() === item.id"
                          [title]="item.state === 1 ? 'คลิกเพื่อเปลี่ยนเป็น ไม่เผยแพร่' : 'คลิกเพื่อเปลี่ยนเป็น เผยแพร่'"
                          (click)="toggleState(item)">
                    <app-status-badge size="sm"
                                      [label]="item.state === 1 ? 'เผยแพร่' : 'ไม่เผยแพร่'"
                                      [variant]="item.state === 1 ? 'success' : 'danger'"/>
                  </button>
                </td>
                <td nowrap>
                  <a [routerLink]="['/wss', item.id]" class="text-decoration-none fw-semibold">{{ item.name || '-' }}</a>
                </td>
                <td nowrap class="text-truncate key-cell font-monospace small" [title]="item.consumerKey">{{ item.consumerKey || '-' }}</td>
                <td nowrap>{{ item.email || '-' }}</td>
                <td nowrap>{{ item.createdName || item.createdId || '-' }}</td>
                <td nowrap>{{ item.createdDate | thaidatetime:{showTime:false} }}</td>
                <td class="text-center sticky-col sticky-col-cell sticky-col-manage-actions">
                  <div class="d-flex gap-1 align-items-center justify-content-center">
                    <a class="btn btn-sm btn-icon" [routerLink]="['/wss', item.id]" [queryParams]="{mode: 'view'}" title="ดูรายละเอียด">
                      <app-search-icon [size]="18"></app-search-icon>
                    </a>
                    <a class="btn btn-sm btn-icon" [routerLink]="['/wss', item.id]" title="แก้ไข">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 20h9"/>
                        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/>
                      </svg>
                    </a>
                    <button class="btn btn-sm btn-icon" (click)="delete(item.id!)" title="ลบ">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 6h18"/>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                        <line x1="10" x2="10" y1="11" y2="17"/>
                        <line x1="14" x2="14" y1="11" y2="17"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-footer bg-white d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <span class="me-2 text-body-secondary">แสดง</span>
      <app-pagesize-select [value]="pageSize()" (valueChange)="pageSize.set($event); load()"/>
      <span class="ms-2 text-body-secondary">จาก {{ collectionSize() }} รายการ</span>
    </div>
    <ngb-pagination [collectionSize]="collectionSize()"
                    [page]="page()"
                    [pageSize]="pageSize()"
                    [maxSize]="5"
                    [rotate]="true"
                    [boundaryLinks]="true"
                    (pageChange)="page.set($event); load()">
    </ngb-pagination>
  </div>
</div>
